<ng-container coreActivitySection="More">
  @let bostonPizzaUI = this.bostonPizzaUI();

  <app-page-header
    class="header"
    (click)="back.emit()"
    coreUserActivityClickTracking="CloseMore"
  />

  <swiper-container
    class="swiper"
    autoplay="true"
    autoplay-delay="10000"
    autoplay-disable-on-interaction="true"
    pagination="true"
    direction="vertical"
    loop="true"
  >
    @if (bostonPizzaUI && (bostonPizzaUI.googleReviewsUrl || bostonPizzaUI.guestSurveyUrl)) {
      <swiper-slide>
        <app-more-slide-review
          [reviewUrl]="bostonPizzaUI.googleReviewsUrl ?? undefined"
          [surveyUrl]="bostonPizzaUI.guestSurveyUrl ?? undefined"
        />
      </swiper-slide>
    }

    <swiper-slide>
      <app-more-slide-app/>
    </swiper-slide>

    <swiper-slide>
      <app-more-slide-social/>
    </swiper-slide>

    <swiper-slide>
      <app-more-slide-work/>
    </swiper-slide>
  </swiper-container>
</ng-container>
